export const manageWarmupData = async (callback, key, flowAPI) => {
  const isSSR = flowAPI.environment.isSSR;
  const compId = flowAPI.controllerConfig.compId;
  const warmupData = flowAPI.controllerConfig.wixCodeApi.window.warmupData;
  const cacheKey = `${compId}_${key}`;
  if (!isSSR) {
    const cache = warmupData.get(cacheKey);
    if (cache) {
      return cache;
    }
  }
  const data = await callback();
  if (isSSR) {
    warmupData.set(cacheKey, data);
  }
  return data;
};
//# sourceMappingURL=manageWarmupData.js.map